interface Props {
  /** Seconds until another attempt is allowed, when the server said. */
  retryAfter: number | null;
  onBack: () => void;
}

function describeWait(seconds: number): string {
  if (seconds < 60) return `${seconds} second${seconds === 1 ? '' : 's'}`;
  const minutes = Math.ceil(seconds / 60);
  return `${minutes} minute${minutes === 1 ? '' : 's'}`;
}

export default function ResultRateLimited({ retryAfter, onBack }: Props) {
  return (
    <div className="space-y-5">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-50 text-amber-600 ring-8 ring-amber-50/60">
          <i className="ri-time-line text-3xl" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-amber-700">TOO MANY ATTEMPTS</h2>
          <p className="mt-1 text-sm text-navy-500">
            {retryAfter
              ? `Please wait ${describeWait(retryAfter)} before trying again.`
              : 'Please wait a moment before trying again.'}
          </p>
        </div>
      </div>

      <button
        onClick={onBack}
        className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-navy-200 bg-white px-4 py-2.5 text-sm font-medium text-navy-800 transition hover:bg-navy-50 cursor-pointer"
      >
        <i className="ri-arrow-left-line" />
        Back to the form
      </button>
    </div>
  );
}
